import React from 'react';
import './ExecutiveSummary.css';

const ExecutiveSummary = () => {
  const metrics = {
    totalEngagement: 30567891,
    activeCelebrities: 156,
    brandPartnerships: 1134,
    avgEngagementPerPost: 14482
  };

  const investmentPotential = {
    conservative: metrics.totalEngagement * 0.001 * 100, // 0.1% conversion at $100
    moderate: metrics.totalEngagement * 0.01 * 100, // 1% conversion at $100
    aggressive: metrics.totalEngagement * 0.001 * 1000 // 0.1% conversion at $1000
  };

  return (
    <div className="executive-summary glass-card">
      <h2 className="section-title">CAA INFLUENCE METRICS (2025 YTD)</h2>
      
      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-icon">🚀</div>
          <div className="metric-value">{(metrics.totalEngagement / 1000000).toFixed(1)}M+</div>
          <div className="metric-label">Total Engagement</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-icon">⭐</div>
          <div className="metric-value">{metrics.activeCelebrities}</div>
          <div className="metric-label">A-List Talents</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-icon">🤝</div>
          <div className="metric-value">{metrics.brandPartnerships.toLocaleString()}</div>
          <div className="metric-label">Brand Partnerships</div>
        </div>
        
        <div className="metric-card">
          <div className="metric-icon">📈</div>
          <div className="metric-value">{metrics.avgEngagementPerPost.toLocaleString()}</div>
          <div className="metric-label">Avg Engagement/Post</div>
        </div>
      </div>

      <div className="investment-potential">
        <h3 className="potential-title">💰 INVESTMENT POTENTIAL</h3>
        <div className="potential-scenarios">
          <div className="scenario">
            <span className="scenario-label">Conservative (0.1% @ $100):</span>
            <span className="scenario-value">${(investmentPotential.conservative / 1000000).toFixed(1)}M</span>
          </div>
          <div className="scenario">
            <span className="scenario-label">Moderate (1% @ $100):</span>
            <span className="scenario-value">${(investmentPotential.moderate / 1000000).toFixed(1)}M</span>
          </div>
          <div className="scenario highlight">
            <span className="scenario-label">Target (0.1% @ $1,000):</span>
            <span className="scenario-value">${(investmentPotential.aggressive / 1000000).toFixed(1)}M</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveSummary;